// extracted by mini-css-extract-plugin
module.exports = {"container":"KpFail_container__yi0mL","title":"KpFail_title__3MNmv"};